import { Box, Divider, BoxProps } from "@mui/material";
import { useTranslation } from "next-i18next";
import { ITagsData } from "src/api/server/extended-search.types";
import { TagsListWithBrokers } from "src/components/pages/search/components/tags-filter/components/tags-list-with-brokers";
import { ArrowLink } from "src/components-mui/base/arrow-link/arrow-link";
import { Button } from "src/components-mui/base/button/button";

const TAGS_FILTER_BODY_CONTENT_TEST_ID = "tags-filter-body-content";

interface ITagsFilterBodyContentProps extends BoxProps {
    tagsData: ITagsData;
    resetTags: () => void;
}

export const TagsFilterBodyContent = ({ tagsData, resetTags, ...boxProps }: ITagsFilterBodyContentProps) => {
    const { t } = useTranslation("extended-search");
    const { faqLink } = tagsData;

    return (
        <Box {...boxProps} data-test-id={TAGS_FILTER_BODY_CONTENT_TEST_ID}>
            <TagsListWithBrokers tagsData={tagsData} />
            <Divider sx={{ pt: 3 }} />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    pt: 2,
                }}
            >
                <Button variant="ghost-underline" size="small" sx={{ ml: -2 }} onClick={resetTags}>
                    {t("buttons.reset-tags")}
                </Button>
                {faqLink && (
                    <ArrowLink sx={{ display: "inline-flex", alignItems: "center", fontSize: "sm" }} href={faqLink.url} target={faqLink.target}>
                        {faqLink.name}
                    </ArrowLink>
                )}
            </Box>
        </Box>
    );
};
